import React, { useState, useEffect, useCallback, useMemo } from "react";
import SearchBar from "../SearchBar/SearchBar";
import FilterAccordion from "./CollapseFilter";
import { API } from "../../API";
import { Button, Checkbox, FormControlLabel, Grid } from "@mui/material";
import { notify } from "react-notify-toast"
import debounce from 'lodash.debounce';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from "moment";
import dayjs from 'dayjs';
import LocationFilter from "./LocationFilter";
import './SearchTeacherFilter.css'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const _ = require('lodash')

const SearchTeacherFilter = (props) => {

	const {
		onSearchTeacher,
		user
	} = props

	const [qualificationList, setQualificationList] = useState([])
	const [levels, setVETLevel] = useState([])

	const [searchFilter, setSearchFilter] = useState({
		name: null,
		can_delivers: [],
		full_can_delivers: [],
		locations: [],
		availability: null,
		search_date: null,
		modality: null,
		level: [],
		hold_cert_iv: null,
	})
	const [vetQualificationSearch, setVETQualificationSearch] = useState({})
	const [searchName, setSearchName] = useState('')

	useEffect(() => {
		const strSearch = window.localStorage.getItem('searchTeacherFilter')
		if(strSearch) {
			const currentFilter = JSON.parse(strSearch)
			setSearchFilter(currentFilter)
			setVETQualificationSearch(currentFilter?.vetQualificationSearch || {})
			setSearchName(currentFilter.name)
		}
		else {
			setSearchFilter({
				name: null,
				can_delivers: [],
				full_can_delivers: [],
				locations: [],
				availability: null,
				search_date: null,
				modality: null,
				level: []
			})
		} 
		API.getQualificationList().then(result => {
			const qualifications = result?.data?.data
			// get all level of VET
			let levels = []
			let levelPriorities = []
			qualifications.filter(item => item.type === 'vet').forEach((item => {
				const subQualifications = item.qualifications
				subQualifications.forEach(ele => {
					if (!levels.includes(ele.level) && ele.level?.length) {
						levels.push(ele.level)
						levelPriorities.push({
							name: ele.level,
							priority: ele.priority
						})
					}
					else if(levels.includes(ele.level) && ele.level?.length && ele.priority) {
						const itemIndex = levelPriorities.findIndex(item => item.name === ele.level)
						levelPriorities = [
						  ...levelPriorities.slice(0, itemIndex),
						  {
							name: ele.level,
							priority: ele.priority
						  },
						  ...levelPriorities.slice(itemIndex + 1)
						]
					}
				})
			}))

			levels.sort((a, b) => {
				const priorityA = levelPriorities.find(item => item.name === a)?.priority || 0;
				const priorityB = levelPriorities.find(item => item.name === b)?.priority || 0;
				return priorityA - priorityB;
			})
			setQualificationList(qualifications)
			setVETLevel(levels)
		})
	}, [])


	const debouncedOnChange = useCallback((
		debounce((key, value, checked, qua = null, vetQualificationSearchData, searchFilterData) => {
			let searchData = {...searchFilterData}
			let newVETQualificationSearch = {...vetQualificationSearchData}
			if(key === 'location') {
				let locations = searchFilterData.locations
				if(value === 'online_only') {
					if(checked) {
						locations = [value]
					}
					else {
						locations = []
					}
				}
				else {
					if(checked && !locations.includes(value)) {
						locations.push(value)
					}
					else if(!checked) {
						locations = locations.filter(ele => ele !== value)
					}
					locations = locations.filter(ele => ele !== 'online_only')
				}
				searchData = {
					...searchFilterData,
					locations 
				}
			}
			else if(key === 'can_deliver') {
				const splitValue = value.split("_id:")?.[0]
				const splitID = value.split("_id:")?.[1]
				// console.log("can_deliver value: ", splitValue, splitID, qua?.title)
				const keyType = qua ? qua._id : 'other'
				const quaTitle = qua ? qua.title : ""
				let newValidUnitValue = vetQualificationSearchData[keyType] || []
				
				let validArr = _.flatten(Object.values(vetQualificationSearchData))
				if (checked) {
					if(quaTitle !== splitValue) {
						// console.log("qua.title !== splitValue")
						newValidUnitValue = vetQualificationSearchData[keyType]?.length ? 
							[...vetQualificationSearchData[keyType], value] : 
							[value]
						newVETQualificationSearch = {
							...vetQualificationSearchData,
							[keyType]: newValidUnitValue.filter(eleValue => eleValue.split("_id:")?.[0] !== quaTitle)
						}
						setVETQualificationSearch(newVETQualificationSearch)
						validArr = _.flatten(Object.values(newVETQualificationSearch))
					}
					else {
						// console.log("qua.title === splitValue")
						newVETQualificationSearch = {
							...vetQualificationSearchData,
							[keyType]: [value]
						}
						setVETQualificationSearch(newVETQualificationSearch)
						validArr = _.flatten(Object.values(newVETQualificationSearch))
						// console.log("validArr: ", validArr)
						
					}
					searchData = {
						...searchFilterData,
						can_delivers: [
							...searchFilterData.can_delivers,
							splitID
						].filter(ele => validArr.map(item => item.split("_id:")?.[1]).includes(ele)),
						full_can_delivers: [
							...searchFilterData.full_can_delivers,
							value
						].filter(ele => validArr.includes(ele))
					}
				} else {
					searchData = {
						...searchFilterData,
						can_delivers: [
							...searchFilterData.can_delivers.filter(item => item !== splitID),
						],
						full_can_delivers: [
							...searchFilterData.full_can_delivers.filter(item => item !== splitValue && item !== value),
						]
					}
					newVETQualificationSearch = {
						...vetQualificationSearchData,
						[keyType]: vetQualificationSearchData[keyType].filter(ele => ele !== value)
					}
					setVETQualificationSearch(newVETQualificationSearch)
				}
			}
			else if(key === 'search_date') {
				searchData = {
					...searchFilterData,
					[key]: value,
					availability: null
				}
			}
			else if(key === 'name') {
				searchData = {
					...searchFilterData,
					[key]: value
				}
			}
			else if(key === 'level') {
				let level = searchFilterData.level
				if(checked && !level.includes(value)) {
					level.push(value)
				}
				else if(!checked) {
					level = level.filter(ele => ele !== value)
				}

				searchData = {
					...searchFilterData,
					level 
				}
			}
			else if (key === 'hold_cert_iv') {
				searchData = {
					...searchFilterData,
					[key]: checked ? value : null,
				}
			}
			else {
				if(checked) {
					searchData = {
						...searchFilterData,
						[key]: value,
						search_date: key === 'availability' ? null : searchData?.search_date
					}
				}
				else {
					searchData = {
						...searchFilterData,
						[key]: null
					}
				}
			}

			if(Object.values(newVETQualificationSearch).find(item => item.length > 0)) {
				let level = searchData.level
				if(level.length > 0) {
					level = level.filter(ele => ele !== 'cert' && ele !== 'bachelor' && ele !== 'diploma')
					level = level.length > 0 ? level : []
					searchData = {
						...searchData,
						level
					}
				}
			}
			setSearchFilter(searchData)
			searchTeacher(searchData)
		}, 600)
	), [])

	const onChange = (key, e, qua = null) => {
		if(key === 'search_date') {
			debouncedOnChange(key, e, true, qua, vetQualificationSearch, searchFilter);
		}
		else if(key === 'name') {
			setSearchName(e.target.value)
			debouncedOnChange(key, e.target.value, e.target.checked, qua, vetQualificationSearch, searchFilter);
		}
    	else {
			debouncedOnChange(key, e.target.value, e.target.checked, qua, vetQualificationSearch, searchFilter);
		}
  	};

	const saveFilter = () => {
		window.localStorage.setItem('searchTeacherFilter', JSON.stringify({...searchFilter, vetQualificationSearch}))
		notify.show('Saved filter successfully')
	}

	const removeFilter = () => {
		window.localStorage.removeItem('searchTeacherFilter')
		notify.show('Removed filter successfully')
		setSearchName('')
		const searchData = {
			name: null,
			can_delivers: [],
			full_can_delivers: [],
			locations: [],
			availability: null,
			search_date: null,
			modality: null,
			level: []
		}
		setSearchFilter(searchData)
		setVETQualificationSearch({})
		searchTeacher(searchData)
	}

	const searchTeacher = (query) => {
		const cloneQuery = {...query}
		const { locations, can_delivers, level } = cloneQuery
		if(locations?.length) {
			locations.forEach((ele, index) => {
				cloneQuery[`locations[${index}]`] = ele
			})
			delete cloneQuery.locations
		}
		if(level?.length) {
			level.forEach((ele, index) => {
				cloneQuery[`level[${index}]`] = ele
			})
			delete cloneQuery.level
		}
		if(can_delivers?.length) {
			can_delivers.forEach((ele, index) => {
				cloneQuery[`can_delivers[${index}]`] = ele
			})
			delete cloneQuery.can_delivers
		}
		delete cloneQuery.full_can_delivers
		onSearchTeacher(cloneQuery)
	}

	return (
		searchFilter && <div className="search-teacher-filters">
		<h2 className="search-teacher-subheading">
			{ user?.is_childcare_centre ? "Search by Educator Name" : "Search by Teacher Name" }
		</h2>
		<div className="w-100 d-flex justify-content-center">
			<SearchBar
				placeholder="Type name"
				onChange={(e) => onChange('name', e)}
				altColours
				value={searchName}
			/>
		</div>


		<hr className="my-4" />
		<h2 className="search-teacher-subheading">
			Filter by Course Type/ Specialisation
		</h2>


		{qualificationList?.length && levels?.length && <FilterAccordion
			qualificationList={qualificationList}
			levels={levels}
			selectedList={searchFilter.full_can_delivers || []}
			vetQualificationSearch={vetQualificationSearch}
			onChangeCategory={(e, qua) => onChange('can_deliver', e, qua)}
			onChangeLevel={(e, qua) => onChange('level', e, qua)}
			showTwoColumns={false}
			includeTeacherCategory
		/>}

		<hr className="my-4" />
		<div className="field-search">
			<Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="location-content"
          id="location"
        >
          <h4>Search by Location</h4>
        </AccordionSummary>
        <AccordionDetails>
					<LocationFilter onChange={(key, e) => onChange(key, e)} searchFilter={searchFilter} />
        </AccordionDetails>
      </Accordion>
		</div>

		<hr className="my-3" />
		<div className="field-search">
			<Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="location-content"
          id="location"
        >
          <h4>Search by Qualifications</h4>
        </AccordionSummary>
        <AccordionDetails>
					<div className="w-100 d-flex justify-content-center flex-column">
						<FormControlLabel
							control={<Checkbox id={'hold_cert_iv'} value={1} checked={searchFilter?.['hold_cert_iv'] == 1} />}
							label={'Holds Certificate IV in Training & Assessment (TAE)'}
							onChange={(e) => onChange('hold_cert_iv', e)}
						/>
					</div>
        </AccordionDetails>
      </Accordion>
		</div>

		<hr className="my-3" />
		<div className="field-search">
			<Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="location-content"
          id="location"
        >
          <h4>Availability</h4>
        </AccordionSummary>
        <AccordionDetails>
					<FormControlLabel
						control={<Checkbox id={'a_nextweek'} value={'next_week'} checked={searchFilter?.['availability'] === 'next_week'} />}
						label={'Available next week'}
						onChange={(e) => onChange('availability', e)}
					/>
					<FormControlLabel
						control={<Checkbox id={'a_next_30_morning'} value={'next_30_morning'} checked={searchFilter?.['availability'] === 'next_30_morning'} />}
						label={'Available mornings for next 30 days'}
						onChange={(e) => onChange('availability', e)}
					/>
					<FormControlLabel
						control={<Checkbox id={'a_next_30_evening'} value={'next_30_evening'} checked={searchFilter?.['availability'] === 'next_30_evening'} />}
						label={'Available evenings for next 30 days'}
						onChange={(e) => onChange('availability', e)}
					/>
					<p className="text-center my-2">Or Search by Date</p>
					<div className="w-100 d-flex justify-content-center">
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<StaticDatePicker
								openTo="day"
								// views={['day', 'month', 'year']}
								componentsProps={{ actionBar: { actions: ['clear'] } }}
								value={searchFilter.search_date ? dayjs(moment(searchFilter.search_date, "DD-MM-YYYY").format("MM-DD-YYYY")) : null}
								onChange={(date) => onChange("search_date", date ? moment(date["$d"]).format("DD-MM-YYYY") : null)}
								onAccept={(date) => onChange("search_date", date ? moment(date["$d"]).format("DD-MM-YYYY") : null)}
								onClose={(date) => onChange("search_date", null)}
							/>
						</LocalizationProvider>
					</div>
        </AccordionDetails>
      </Accordion>
		</div>

		{
			Object.values(vetQualificationSearch).find(item => item.length > 0) && (
			<>
				<hr className="my-3" />
				<div className="">
					<h2 className="search-teacher-subheading-no-margin mb-3">Qualifications</h2>
					<div className="w-100 d-flex justify-content-center flex-column">
					<Grid container spacing={2}>
							<>
								<Grid item xs={6} style={{ "paddingTop": "4px" }}>
									<FormControlLabel
										control={<Checkbox id={'junior'} value={'junior'} checked={searchFilter?.level?.includes('junior')} />}
										label={'Junior'}
										onChange={(e) => onChange('level', e)}
										style={{ "marginBottom": "2px" }}
									/>
								</Grid>
								<Grid item xs={6} style={{ "paddingTop": "4px" }}>
									<FormControlLabel
										control={<Checkbox id={'senior'} value={'senior'} checked={searchFilter?.level?.includes('senior')} />}
										label={'Senior'}
										onChange={(e) => onChange('level', e)}
										style={{ "marginBottom": "2px" }}
									/>
								</Grid>
							</>
					</Grid>
					</div>
				</div>
			</>
			)
		}

		{/* <hr className="my-4" /> */}
		{/* <div className="">
			<h2 className="search-teacher-subheading-no-margin">Modality</h2>
			<FormControlLabel
				control={<Checkbox id={'online_only'} value={'online_only'} checked={searchFilter?.['modality'] === 'online_only'} />}
				label={'Can teach online'}
				onChange={(e) => onChange('modality', e)}
			/>
			<FormControlLabel
				control={<Checkbox id={'hybrid'} value={'hybrid'} checked={searchFilter?.['modality'] === 'hybrid'} />}
				label={'Can teach hybrid online/F2F'}
				onChange={(e) => onChange('modality', e)}
			/>
		</div> */}
		<div className="my-4 text-center d-flex flex-row">
			<Button className="mx-2" variant="outlined" onClick={() => saveFilter()}>Save these filters on this device</Button>
			<Button className="mx-2" variant="outlined" onClick={() => removeFilter()}>Clear saved filters</Button>
		</div>
	</div>
	)
}

export default SearchTeacherFilter